import { lang } from '@umu/ukit-lang';
/**
 * @description 全屏弹窗，用于需要展示页面又不跳转的情况，
 * 它区别于 iframe, 里面放与页面相关的交互
 * @author wayou
 * @date
 */

import React from 'react';

import './pagePanel.scss';

import CoverPage, { ICoverPageProps } from '../@coverPage/coverPage';
import ConfigurableHeader, { IConfigurableHeaderConfig } from '../@configurableHeader/configurableHeader';

interface IProps extends ICoverPageProps {
    hideHeader?: boolean;
    clsName?: string;
    title: string;
    leftTitle: string;
    leftChild?: React.ReactElement;
    leftClsName: string;
    rightTitle: string;
    rightChild?: React.ReactElement;
    rightClsName: string;
    leftCallback(): void;
    rightCallback?(): void;
    hitBottomCallback?(): void;
}

class PagePanel extends CoverPage<IProps, {}> {
    public static defaultProps: Partial<IProps> = {
        clsName: '',
        title: '',
        leftTitle: lang('返回'),
        rightTitle: lang('提交'),
        rightClsName: '',
        leftClsName: '',
    };

    constructor(props: IProps) {
        super(props);

        this.leftCallback = this.leftCallback.bind(this);
        this.rightCallback = this.rightCallback.bind(this);
    }

    public leftCallback() {
        const props = this.props;
        if (props.leftCallback) {
            props.leftCallback();
        }
    }

    public rightCallback() {
        const props = this.props;
        if (props.rightCallback) {
            props.rightCallback();
        }
    }

    public getHeaderConfig(): {
        [key: string]: IConfigurableHeaderConfig;
    } {
        const props = this.props;
        return {
            leftProp: {
                label: props.leftTitle,
                child: props.leftChild,
                clsName: props.leftClsName ? props.leftClsName : 'btn-text',
                callback: props.leftCallback,
            },
            centerProp: {
                label: props.title,
                clsName: 'btn-text truncate-text',
            },
            rightProp: {
                label: props.rightTitle,
                child: props.rightChild,
                clsName: props.rightClsName ? props.rightClsName : 'btn-text',
                callback: props.rightCallback,
            },
        };
    }

    public render() {
        const props = this.props;
        return (
            <CoverPage clsName={'page-panel ' + props.clsName} hitBottomCallback={props.hitBottomCallback}>
                {props.hideHeader ? null : (
                    <ConfigurableHeader
                        clsName="page-panel-header cover-page-fixed-header"
                        config={this.getHeaderConfig()}
                    />
                )}
                <div className="page-panel-body">{this.props.children}</div>
            </CoverPage>
        );
    }
}

export default PagePanel;
